var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.42 1.57a5.38 5.38 0 0 0-7.65.05l-.4.47a1 1 0 0 0 .1 1.41 1 1 0 0 0 1.41-.1l.35-.42a3.36 3.36 0 0 1 5.76 2.4c0 .9-.35 1.75-.94 2.34l-.47.41a1 1 0 0 0 .65 1.75c.23 0 .47-.08.66-.25l.52-.45a5.33 5.33 0 0 0 1.57-3.8c0-1.45-.56-2.8-1.57-3.8h.01Zm-4.5 3.1L4.67 9.92a1 1 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l5.25-5.25a1 1 0 0 0-1.41-1.41zm-2.15 8.4.3-.4a1 1 0 0 1 1.4-.21 1 1 0 0 1 .21 1.4l-.35.47-.1.1a5.42 5.42 0 0 1-7.64 0 5.37 5.37 0 0 1-.04-7.57l.08-.08.46-.4a1 1 0 0 1 1.41.09c.36.4.32 1.04-.09 1.41l-.46.4a3.36 3.36 0 0 0 .04 4.74 3.44 3.44 0 0 0 4.78.05",
    clipRule: "evenodd"
  })));
};
export default SvgLink;